export const USER_DATA_REQUEST_STATUS = 'USER_DATA_REQUEST_STATUS'
export const USER_ACCOUNT_FORM_DATA_REQUEST_STATUS = 'USER_ACCOUNT_FORM_DATA_REQUEST_STATUS'
export const USER_PROFILE = 'USER_PROFILE'
export const SHOW_USER_DATA = 'SHOW_USER_DATA'